import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import VueBarcode from 'vue-barcode'
import printJS from 'print-js'
import Printd from 'printd'
import Validator from 'vee-validate'
import CryptoJS from 'crypto-js';

export default {
  name: 'client',
  components: {
    Paginate,
    DatePicker,
    'barcode': VueBarcode

  },
  data: function() {
    return {
      //modalShow used for close the active/inactive modal(default)
      listShippingDocsData: [],
      listClientData:[],
      ordermaster: {},
      orderDetails: [],
      clientdata: {},
      pageno: 0,
      pagecount: 0,
      orderid: '',
      awbno: '',
      shippingdate: '',
      invoicemodal: false,
      poid: '',
      warehouseid:0,
      clientid:'',
      model: {
        igstamount: 0,
        sgstamount: 0,
        cgstamount: 0,
        qty:0,
        mrp:0,
      },
      searchFlag:false,
      resultCount:0,

    }
  },
  created: function() {},
  filters: {
    moment: function(date) {
      return moment(date).format('DD-MM-YYYY');
    }
  },
  computed: {
    total: function() {
      //console.log(this.orderDetails);
      return this.orderDetails.reduce(function(total, item) {

        return total + item.mrp;
      }, 0);
    },

    igstamount: function() {
      //console.log(this.orderDetails);
      return this.orderDetails.reduce(function(igstamount, item) {

        return igstamount + item.mrp * (item.igst / 100);
      }, 0);
    },
    sgstamount: function() {
      //console.log(this.orderDetails);
      return this.orderDetails.reduce(function(sgstamount, item) {

        return sgstamount + item.mrp * (item.sgst / 100);
      }, 0);
    },
    cgstamount: function() {
      //console.log(this.orderDetails);
      return this.orderDetails.reduce(function(cgstamount, item) {

        return cgstamount + item.mrp * (item.cgst / 100);
      }, 0);
    },
    shippingcharges: function() {
      //console.log(this.orderDetails);
      return this.orderDetails.reduce(function(shippingcharges, item) {

        return shippingcharges + item.shippingcharges;
      }, 0);
    },
    qty: function() {
      //console.log(this.orderDetails);
      return this.orderDetails.reduce(function(qty, item) {

        return qty + parseInt(item.quantity) ;
      }, 0);
    },
    qty: function() {
      //console.log(this.orderDetails);
      return this.orderDetails.reduce(function(qty, item) {

        return qty + parseInt(item.quantity) ;
      }, 0);
    },
    mrp: function() {
      //console.log(this.orderDetails);
      return this.orderDetails.reduce(function(mrp, item) {

        return mrp + parseInt(item.mrp) ;
      }, 0);
    },

  },

  // when a page loads,mounted() will be call
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.warehouseid = userdetail.warehouseid;

    this.pageno = 0
    this.pagenodetail = 0
    //this.getShippingdocsMaster()
    this.getClientList()
  },
  methods: {

    calcuateTaxable(mrp,qty,discount,igst,cgst,sgst){
      var  actual_total = mrp*qty;
      if(discount==0 || discount=="")
      {
        if(igst==0)
        {
           var total_tax = cgst+sgst;
           return actual_total/ (1+(total_tax/100));
        }
        else
        {
            return  actual_total/ (1+(igst/100));
        }
      }
      else
      {

        var discounted_price = actual_total - actual_total * (discount/100);
          if(igst==0)
          {
              var total_tax = cgst+sgst;
              return discounted_price/ (1+(total_tax/100));
          }
          else
          {
              return  discounted_price/ (1+(igst/100));
          }
      }
    },
    calcuateigstAmount(mrp,qty,discount,igst)
    {
      var  actual_total = mrp*qty;
      if(discount==0 || discount=="")
      {

            var igst_amount = actual_total * (igst/100);
            return igst_amount;

      }
      else {

        var discounted_price = actual_total - actual_total * (discount/100);

              var igst_amount = discounted_price * (igst/100);
              return igst_amount;

      }
    },
    calcuatecgstAmount(mrp,qty,discount,cgst)
    {
      var  actual_total = mrp*qty;
      if(discount==0 || discount=="")
      {

            var cgst_amount = actual_total * (cgst/100);
            return cgst_amount;

      }
      else {

        var discounted_price = actual_total - actual_total * (discount/100);

              var cgst_amount = discounted_price * (cgst/100);
              return cgst_amount;

      }
    },
    calcuatesgstAmount(mrp,qty,discount,sgst)
    {
      var  actual_total = mrp*qty;
      if(discount==0 || discount=="")
      {

            var sgst_amount = actual_total * (sgst/100);
            return sgst_amount;

      }
      else {

        var discounted_price = actual_total - actual_total * (discount/100);

              var sgst_amount = discounted_price * (sgst/100);
              return sgst_amount;

      }
    },

    getScore (val) {
      if (val==null) {
        return '0.00';
      }
      else {
        return parseFloat(val).toFixed(2);
      }
    },
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    //open new form(popup)
    print() {
   const d = new Printd();
   var buffer = '';

   var cssText = `
           body{
          -webkit-print-color-adjust:exact;
        }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }

           table, td, th {
             border-style: solid;
        border-width: 1px;

        margin-bottom: 10px;
        border-color: rgba(0,0,255,0.25);
               padding:5px;
           }
         pre {
           color: #c7254e;
         }
         .text-right{
           text-align:right;
         }

         .clientdetails{
           margin-top:-40px;
           font-size:12px;
         }
         @media print {
         .text-primary th{
           background-color:rgb(226, 216, 216) !important;
           color:black !important;
           font-size:20px !important;
         }

        }
        `


        d.print( document.getElementById('printPoContent'), cssText );


 },

 //open new form(popup)
 printTaxInvoice() {
const d = new Printd();
var buffer = '';

var cssText = `
        body{
       -webkit-print-color-adjust:exact;
     }
        table {
            border-collapse: collapse;
            margin-left:0px !important;
        }

        table, td, th {
          border-style: solid;
     border-width: 1px;

     margin-bottom: 10px;
     border-color: rgba(0,0,255,0.25);
            padding:5px;
        }
      pre {
        color: #c7254e;
      }
      .text-right{
        text-align:right;
      }

      .clientdetails{
        margin-top:-40px;
        font-size:12px;
      }
      @media print {
      .text-primary th{
        background-color:rgb(226, 216, 216) !important;
        color:black !important;
        font-size:20px !important;
      }

     }
     `


     d.print( document.getElementById('taxInvoice_Content'), cssText );


},


    generateInvoice(data) {
      //console.log(data);
      //this.invoicemodal = true;
      this.poid = data.orderid

      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      /*  Calling the function for getting the cliend id*/
      this.input = ({
        orderid: data.orderid,
        warehouseid: this.warehouseid,
        clientid: this.clientid
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getDataInvoice',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
            this.ordermaster = result.data.data.master[0];
            this.orderDetails = result.data.data.orderdetails;
            this.clientdata = result.data.data.clientData[0];

            setTimeout(function() {
            //this.sendprintCommand()
            this.print()
          }.bind(this), 1000)


          }, error => {
            console.error(error)
          }

        )



      /*  End Function for invoice */
    },

    generateTaxInvoice(data) {

      this.poid = data.orderid

      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      /*  Calling the function for getting the cliend id*/
      this.input = ({
        orderid: data.orderid,
        warehouseid: this.warehouseid,
        clientid: this.clientid
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getDataInvoice',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
            this.ordermaster = result.data.data.master[0];
            this.orderDetails = result.data.data.orderdetails;
            this.clientdata = result.data.data.clientData[0];

            setTimeout(function() {
            //this.sendprintCommand()
            this.printTaxInvoice()
          }.bind(this), 1000)


          }, error => {
            console.error(error)
          }

        )



      /*  End Function for invoice */
    },
    //to reset search form
    resetSearchForm() {
      this.awbno = '';
      this.orderid = '';
      this.shippingdate = '';
      this.listShippingDocsData=[];
      this.pageno = 0;
      this.pagecount = 0;
      this.resultCount = 0;
      this.clientid = '';
    },
    //to close the Inward Details popup
    closeInvoiceModal() {
      this.invoicemodal = false
    },

    //to Shipping master List
    getShippingdocsMaster() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      var cr_date = '';
      if (this.shippingdate == '') {
        cr_date = '';
      } else {
        cr_date = this.dateFormat(this.shippingdate)
      }

      this.input = ({
        offset: this.pageno,
        limit: 10,
        awbno: this.awbno,
        orderid: this.orderid,
        shippingdate: cr_date,
        warehouseid: this.warehouseid,
        clientid: this.clientid
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getShippingListMaster',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listShippingDocsData = result.data.data.rows

          let totalRows = result.data.data.count
          this.resultCount = result.data.data.count
          if(this.resultCount > 0)
          {
            if (totalRows < 10) {
              this.pagecount = 1
            } else {
              this.pagecount = Math.ceil(totalRows / 10)
            }
          }

        }, error => {
          console.error(error)
        })
    },
    //to Shipping master List Search
    getShippingdocsMasterSearch() {

      this.pageno = 0;
      this.pagecount = 0;
      this.resultCount = 0;
      this.searchFlag = true;
      this.listShippingDocsData=[];
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      var cr_date = '';
      if (this.shippingdate == '') {
        cr_date = '';
      } else {
        cr_date = this.dateFormat(this.shippingdate)
      }

      this.input = ({
        offset: this.pageno,
        limit: 10,
        awbno: this.awbno,
        orderid: this.orderid,
        shippingdate: cr_date,
        warehouseid: this.warehouseid,
        clientid: this.clientid
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getShippingListMaster',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listShippingDocsData = result.data.data.rows

          let totalRows = result.data.data.count
          this.resultCount = result.data.data.count
          if(this.resultCount > 0)
          {
              if (totalRows < 10) {
                this.pagecount = 1
              } else {
                this.pagecount = Math.ceil(totalRows / 10)
              }
         }
        }, error => {
          console.error(error)
        })
    },
    // Get Merchant List
    getClientList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        offset: 0,
        limit: 100,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'clientMaster',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listClientData = result.data.rows
        }, error => {
          console.error(error)
        })
    },
    getNewClientData(){
       if(this.clientid == "")
       {
          return false;
       }
       else {
         this.pageno = 0;
         this.pagecount = 0;
         this.searchFlag = false;
         this.shippingdate = '';
         this.getShippingdocsMaster();
       }

    },
    //to get target id in edit action
    getInwardDetailData(data) {

      this.$validator.reset();
      this.errors.clear();
    },
    //to get pagination
    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * 10
      this.getInwardMasterData()
    },

    number2text(value)
    {

        var res='';
          var fraction = Math.round(this.frac(value)*100);
          var f_text  = "";

          if(fraction > 0) {
              f_text = "And "+this.convert_number(fraction)+" Paise";
          }

          return  this.convert_number(value)+" Rupees "+f_text+" Only";

      },
      frac(f)
       {
                return f % 1;
      },
      convert_number(number)
      {
          if ((number < 0) || (number > 999999999))
          {
              return "NUMBER OUT OF RANGE!";
          }
          var Gn = Math.floor(number / 10000000);  /* Crore */
          number -= Gn * 10000000;
          var kn = Math.floor(number / 100000);     /* lakhs */
          number -= kn * 100000;
          var Hn = Math.floor(number / 1000);      /* thousand */
          number -= Hn * 1000;
          var Dn = Math.floor(number / 100);       /* Tens (deca) */
          number = number % 100;               /* Ones */
          var tn= Math.floor(number / 10);
          var one=Math.floor(number % 10);
          var res = "";

          if (Gn>0)
          {
              res += (this.convert_number(Gn) + " Crore");
          }
          if (kn>0)
          {
                  res += (((res=="") ? "" : " ") +
                  this.convert_number(kn) + " Lakh");
          }
          if (Hn>0)
          {
              res += (((res=="") ? "" : " ") +
                  this.convert_number(Hn) + " Thousand");
          }

          if (Dn)
          {
              res += (((res=="") ? "" : " ") +
                  this.convert_number(Dn) + " Hundred");
          }


          var ones = Array("", "One", "Two", "Three", "Four", "Five", "Six","Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen","Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen","Nineteen");
      var tens = Array("", "", "Twenty", "Thirty", "Fourty", "Fifty", "Sixty","Seventy", "Eighty", "Ninety");

          if (tn>0 || one>0)
          {
              if (!(res==""))
              {
                  res += " And ";
              }
              if (tn < 2)
              {
                  res += ones[tn * 10 + one];
              }
              else
              {

                  res += tens[tn];
                  if (one>0)
                  {
                      res += (" " + ones[one]);
                  }
              }
          }

          if (res=="")
          {
              res = "zero";
          }
           //alert(res);
          return res;
      },



  }// END Mounted
}



// WEBPACK FOOTER //
// ./src/views/components/shippingdocs/shippingdocs.component.js